import Vue from 'vue'

module.exports = new Vue()



// WEBPACK FOOTER //
// ./src/components/helper/eventbus.js